import axios from "axios";
import { dispatchtoast, removeLocalStorageItem, showError } from "../../Utils";


export const version = "api/v1/";
export const AUTH_ENDPOINT =
  process.env.REACT_APP_NODE_ENV === "dev"
    ? `http://localhost:3001/api/v1`
    : "staging"
    ? `https://api.eztips.com/api/v1/admin`
    : "https://prod.eztips.com/api/v1";
const baseURL = process.env.REACT_APP_API_URL;


export const AuthService = axios.create({
  baseURL,
});

const handleResponse = (response) => {
  if (response.data.status || response.data.success) {
    return response.data;
  } else if (response.data.formErrors) {
    showError(response.data.formErrors);
  } else if (response.data.validationError) {
    showError(response.data.validationError);
  } else {
    dispatchtoast(response.data.message ?? response.data.error, true);
  }
  return response.data;
};
const handleError = (error) => {
  const { status } = error?.response;
  if (status === 401) {
    dispatchtoast(error?.response.data.message ?? error?.response.data.msg, true);
    removeLocalStorageItem("isLoggedIn");
    removeLocalStorageItem("accessToken");
    window.location.href = "/";
  }
  if (status && status >= 400 && status < 500) {
    if (error.response.data.formErrors) {
      showError(error.response.data.formErrors);
    } else if (error.response.data.validationError) {
      showError(error.response.data.validationError);
    } else {
      dispatchtoast(error?.response.data.message ?? error?.response.data.error, true);
    }
  } else if (status && status >= 500) {
    dispatchtoast(error?.response.data.message ?? error?.response.data.msg, true);
  }
  return Promise.reject(error);
};
// Add a request interceptor
AuthService.interceptors.request.use((config) => {
  // Add the JWT token to the request headers
  // if (jwtToken) {
  //   config.headers['Authorization'] = `jwt_token=${jwtToken}`;
  // }
  // Add other headers if needed
  // config.headers['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});
// Add a response interceptor
AuthService.interceptors.response.use(
  (response) => handleResponse(response),
  (error) => {
    // Handle errors if needed
    handleError(error);
  }
);

//TemporarilyService
export const HOMEPAGE_ENDPOINT =
  process.env.REACT_APP_NODE_ENV === "dev"
    ? `http://localhost:3001/api/v1`
    : "staging"
    ? `https://stagingapi.eztips.com/api/v1`
    : "https://prod.eztips.com/api/v1";

export const HomePageService = axios.create({
  baseURL,
});

// Add a request interceptor
HomePageService.interceptors.request.use((config) => {
  // Add the JWT token to the request headers
  // if (jwtToken) {
  //   config.headers['Authorization'] = `jwt_token=${jwtToken}`;
  // }
  // Add other headers if needed
  config.headers["X-Timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});
// Add a response interceptor
HomePageService.interceptors.response.use(
  (response) => handleResponse(response),
  (error) => {
    // Handle errors if needed
    handleError(error);
  }
);
